export default [
    // LEADS INDEX
    {
        path: '/conveyancing/residential/equity/leads',
        name: 'residential.equity.leads',
        component: () => import('@/views/dashboard/LeadsIndex.vue'),
        meta: {
            service: 'res-equity',
            type: 'lead',
            smallMenu: true,
            active: 'residential'
        },
    },
    // LEADS SINGLE
    {
        path: '/conveyancing/residential/equity/leads/view/:reference?',
        name: 'residential.equity.leads.view',
        component: () => import('@/views/dashboard/LeadSingle.vue'),
        meta: {
            service: 'res-equity',
            type: 'lead',
            smallMenu: true,
            active: 'residential'
        },
    },

    // QUOTES INDEX
    {
        path: '/conveyancing/residential/equity/quotes',
        name: 'residential.equity.quotes',
        component: () => import('@/views/dashboard/residential/equity/ResidentialEquityQuotesIndex.vue'),
        meta: {
            service: 'res-equity',
            type: 'quote',
            smallMenu: true,
            active: 'residential'
        },
    },

    // QUOTES SINGLE
    {
        path: '/conveyancing/residential/equity/quotes/view/:reference?',
        component: () => import('@/views/layouts/SingleQuoteWrapper.vue'),
        props: true,
        meta: { 
            service: 'res-equity',
            type: 'quote',
            smallMenu: true,
            active: 'residential'
        },
        children: [
            {
                path: '',
                name: 'services.equity.quote.view',
                component: () => import('@/components/services/QuoteDetailsTab.vue'),
                props: true,
            },
            {
                path: 'summary',
                name: 'services.equity.quote.view.summary',
                component: () => import('@/components/dashboard/residential/equity/ResidentialEquityQuoteSummary.vue'),
                props: true,
            },
            {
                path: 'fees',
                name: 'services.equity.quote.view.fees',
                component: () => import('@/components/dashboard/misc/QuoteMatterFeesTab.vue'),
                props: true,
            },
            {
                path: 'activity',
                name: 'services.equity.quote.view.activity',
                component: () => import('@/components/dashboard/misc/QuoteMatterActivityTab.vue'),
                props: true,
            },
        ],
    },
];